import { LookingDog } from "@/app/(public)/shared/components/LookingDog";

/**
 * Big "nowadays" wordmark at the very bottom of the public footer, with the
 * party-hat dog hiding below the edge. The dog rises while the footer is
 * hovered and its eyes follow the cursor.
 *
 * Must render inside an element with the `group/footer` class.
 *
 * @returns The wordmark strip with the dog.
 */
export const FooterWordmark = () => (
  <div className="relative w-full h-[clamp(96px,17vw,250px)] overflow-hidden">
    <div
      aria-hidden="true"
      className="absolute inset-x-0 top-1 text-center whitespace-nowrap select-none font-[520] leading-[0.82] tracking-[-0.06em] text-[clamp(120px,23vw,340px)] text-[color:var(--landing-button-secondary-bg)]"
    >
      nowadays
    </div>

    <LookingDog
      sizes="150px"
      className="absolute right-[7%] bottom-0 w-[clamp(84px,11vw,150px)] translate-y-[72%] transition-transform duration-[550ms] ease-[cubic-bezier(0.55,0,0.45,1)] group-hover/footer:translate-y-[10%] group-hover/footer:duration-500 group-hover/footer:ease-[cubic-bezier(0.22,1,0.36,1)] motion-reduce:translate-y-[10%] motion-reduce:transition-none"
    />
  </div>
);
